export const CALENDAR_PERIOD_6_MONTHS = 6;
export const CALENDAR_PERIOD_12_MONTHS = 12;
/* computation based on
 * width = (group + 1) * this.daySizeWithSpace + this.getExtraWidthPadding(group);
 * (see activity_calendar.js)
 */
export const OVERVIEW_CALENDAR_BREAKPOINT = 918;

export const SNIPPET_MAX_LIST_COUNT = 20;
